import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { unescape } from 'lodash';
import { filter } from 'rxjs/operators';
import { PollDataService, TrackingService } from '@services/index';
import { AuthService } from '@examsoft/es-login';
var PollQuestionComponent = /** @class */ (function () {
    function PollQuestionComponent(trackingService, authService, pollDataService, route, router) {
        var _this = this;
        this.trackingService = trackingService;
        this.authService = authService;
        this.pollDataService = pollDataService;
        this.route = route;
        this.router = router;
        this.questionState = 'notReady';
        this.questionIndex = 0;
        this.selectedChoices = [];
        this.shortAnswers = [];
        this.questionAnswered = false;
        this.esId = this.authService.user['custom:es-id'];
        router.events
            .pipe(filter(function (event) {
            return event instanceof NavigationStart;
        }))
            .subscribe(function (event) {
            _this.pageChange = event.navigationTrigger;
        });
    }
    PollQuestionComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onPollUpdatedSubscription()];
                    case 1:
                        _a.sent();
                        this.onQuestionStatusUpdatedSubscription();
                        this.onDeletedResponseSubscription();
                        return [2 /*return*/];
                }
            });
        });
    };
    PollQuestionComponent.prototype.onPollUpdatedSubscription = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d;
            var _this = this;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        this.pollId = this.route.snapshot.params.pollid;
                        _a = this;
                        return [4 /*yield*/, this.pollDataService.getPoll(this.pollId)];
                    case 1:
                        _a.poll = _e.sent();
                        _b = this;
                        return [4 /*yield*/, this.pollDataService.getPollQuestion(this.pollId, this.poll.currentQuestion)];
                    case 2:
                        _b.question = _e.sent();
                        _c = this;
                        return [4 /*yield*/, this.pollDataService.getStudentResponses(this.esId, "response#" + this.pollId + "#" + this.question.id)];
                    case 3:
                        _c.responses = _e.sent();
                        this.pollDataService.updateLastAccessed(this.esId, this.pollId);
                        this.setPollDetails();
                        this.setQuestionStatus();
                        this.setStatusPrompt();
                        if (this.pollSubscription && this.pollSubscription.unsubscribe) {
                            this.pollSubscription.unsubscribe();
                        }
                        _d = this;
                        return [4 /*yield*/, this.pollDataService.getPollUpdates(this.pollId).subscribe({
                                next: function (poll) { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
                                    return [2 /*return*/, this.handlePollUpdated(poll)];
                                }); }); },
                                error: function (err) {
                                    _this.pollSubscription.unsubscribe();
                                    _this.onPollUpdatedSubscription();
                                },
                            })];
                    case 4:
                        _d.pollSubscription = _e.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PollQuestionComponent.prototype.handlePollUpdated = function (poll) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.poll = tslib_1.__assign({}, this.poll, poll);
                        if (this.poll.status === 'complete') {
                            this.routeCompletedPoll();
                            return [2 /*return*/];
                        }
                        this.pollId = this.poll.id;
                        this.questionState = 'notReady';
                        _a = this;
                        return [4 /*yield*/, this.pollDataService.getPollQuestion(this.pollId, this.poll.currentQuestion)];
                    case 1:
                        _a.question = _c.sent();
                        _b = this;
                        return [4 /*yield*/, this.pollDataService.getStudentResponses(this.esId, "response#" + this.pollId + "#" + this.question.id)];
                    case 2:
                        _b.responses = _c.sent();
                        this.setPollDetails();
                        this.setQuestionStatus();
                        this.setStatusPrompt();
                        this.onQuestionStatusUpdatedSubscription();
                        this.onDeletedResponseSubscription();
                        return [2 /*return*/];
                }
            });
        });
    };
    PollQuestionComponent.prototype.onQuestionStatusUpdatedSubscription = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (this.questionStatusSubscription && this.questionStatusSubscription.unsubscribe) {
                    this.questionStatusSubscription.unsubscribe();
                }
                this.questionStatusSubscription = this.pollDataService
                    .getQuestionStatusUpdates(this.pollId, this.question.id)
                    .subscribe({
                    next: function (q) { return _this.handleQuestionStatusUpdated(q); },
                    error: function (err) {
                        _this.questionStatusSubscription.unsubscribe();
                        _this.onQuestionStatusUpdatedSubscription();
                    },
                });
                return [2 /*return*/];
            });
        });
    };
    PollQuestionComponent.prototype.handleQuestionStatusUpdated = function (question) {
        this.question = tslib_1.__assign({}, this.question, { questionStatus: question.questionStatus });
        this.setPollDetails();
        this.setQuestionStatus();
        this.setStatusPrompt();
    };
    PollQuestionComponent.prototype.onDeletedResponseSubscription = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (this.responseDeleteSubscription && this.responseDeleteSubscription.unsubscribe) {
                    this.responseDeleteSubscription.unsubscribe();
                }
                this.responseDeleteSubscription = this.pollDataService
                    .getResponseDeleteUpdates(this.esId, "response#" + this.poll.id + "#" + this.question.id)
                    .subscribe({
                    next: function (r) { return _this.handleDeletedResponse(r); },
                    error: function (err) {
                        _this.responseDeleteSubscription.unsubscribe();
                        _this.onDeletedResponseSubscription();
                    },
                });
                return [2 /*return*/];
            });
        });
    };
    PollQuestionComponent.prototype.handleDeletedResponse = function (response) {
        this.responses = this.responses.filter(function (resp) {
            return resp.userId !== response.userId && resp.responseId !== response.responseId;
        });
        this.setPollDetails();
        this.setQuestionStatus();
        this.setStatusPrompt();
    };
    PollQuestionComponent.prototype.setQuestionStatus = function () {
        var _this = this;
        if (!this.responses || this.responses.length === 0) {
            this.questionAnswered = false;
            return;
        }
        this.questionAnswered =
            this.responses.findIndex(function (resp) {
                return "response#" + _this.poll.id + "#" + _this.question.id === resp.responseId;
            }) > -1;
    };
    PollQuestionComponent.prototype.setPollDetails = function () {
        var _this = this;
        this.pollStatus = this.poll.status;
        this.questionIndex = this.poll.currentQuestion;
        if (this.question.type === 'short_answer') {
            this.shortAnswers = this.question.fitbAnswer.blankAnswers.map(function (choice, idx) {
                console.log('What is Choice in Poll Question', choice);
                return {
                    blankUID: choice.blankUID,
                    userAnswer: '',
                    choiceType: choice.choiceType,
                    options: _this.convertOptions(choice.options),
                };
            });
        }
        this.questionState = 'ready';
    };
    PollQuestionComponent.prototype.convertOptions = function (options) {
        var convertedOptions = [];
        options.forEach(function (option) {
            var convertedOption = unescape(option);
            convertedOptions.push(convertedOption);
        });
        return convertedOptions;
    };
    PollQuestionComponent.prototype.ngOnDestroy = function () {
        this.pollSubscription && this.pollSubscription.unsubscribe();
        this.responseDeleteSubscription && this.responseDeleteSubscription.unsubscribe();
        this.questionStatusSubscription && this.questionStatusSubscription.unsubscribe();
    };
    PollQuestionComponent.prototype.setStatusPrompt = function () {
        if (this.pollStatus === 'notactive') {
            this.statusPrompt = 'WaitingToBegin';
        }
        else if ((this.question.questionStatus === 'closed' && !this.isLastQuestion()) ||
            (this.pollStatus === 'active' && this.questionAnswered && !this.isLastQuestion())) {
            this.statusPrompt = 'WaitingForNextQuestion';
        }
        else if (((this.pollStatus === 'active' && this.questionAnswered) || this.question.questionStatus === 'closed') &&
            this.isLastQuestion()) {
            this.statusPrompt = 'WaitingForCompleted';
        }
        else if (this.pollStatus === 'active' && !this.questionAnswered) {
            this.statusPrompt = 'Ready';
        }
        this.trackingService.addPageAction('student-poll-status', {
            pollId: this.poll.id,
            questionId: this.question.id,
            status: this.statusPrompt,
        });
        this.questionState = 'ready';
    };
    PollQuestionComponent.prototype.routeCompletedPoll = function () {
        var _this = this;
        this.pollDataService.completeUserPoll(this.esId, this.pollId).then(function () {
            _this.statusPrompt = 'Completed';
            _this.pollDataService.pollHistory.next(_this.poll.id);
            _this.router.navigate(['launcher']);
        });
    };
    PollQuestionComponent.prototype.onSubmit = function () {
        var _this = this;
        var pollQuestionId = this.poll.id + ':' + this.question.id;
        var questionResponse = this.question.type === 'short_answer' ? this.addShortAnswerResponse() : this.addMCAnswerResponse();
        this.questionState = 'notReady';
        this.trackingService.addPageAction('student-poll-submit', {
            pollId: this.poll.id,
            questionId: this.question.id,
            status: this.statusPrompt,
        });
        questionResponse.then(function (data) {
            _this.responses.push(data);
            _this.selectedChoices = [];
            _this.setPollDetails();
            _this.setQuestionStatus();
            _this.setStatusPrompt();
        });
    };
    PollQuestionComponent.prototype.addShortAnswerResponse = function () {
        var responseDetails = {
            userId: this.esId,
            portalQid: this.question.id,
            responseType: 'text',
            shortAnswerBlanks: this.shortAnswers.filter(function (data) { return data.userAnswer.length || typeof data.userAnswer === 'number'; }),
        };
        //We need to return an array because mc questions support multiple responses
        return this.pollDataService.addResponseToPoll(this.esId, this.question.id, this.pollId, responseDetails);
    };
    PollQuestionComponent.prototype.addMCAnswerResponse = function () {
        var responseDetails = {
            userId: this.esId,
            portalQid: this.question.id,
            responseType: 'index',
            choiceIndexes: [],
        };
        this.selectedChoices.forEach(function (choice) {
            responseDetails.choiceIndexes.push(choice);
        });
        return this.pollDataService.addResponseToPoll(this.esId, this.question.id, this.pollId, responseDetails);
    };
    PollQuestionComponent.prototype.receiveChoice = function ($event) {
        this.selectedChoices = $event;
    };
    PollQuestionComponent.prototype.receiveAnswer = function ($event, i) {
        this.shortAnswers[i].userAnswer = $event;
    };
    PollQuestionComponent.prototype.isLastQuestion = function () {
        return !(this.poll && this.questionIndex < this.poll.numQuestions - 1);
    };
    PollQuestionComponent.prototype.canSubmitAnswer = function () {
        var _this = this;
        var checkMcAnswer = function () { return _this.selectedChoices.length; };
        var checkShortAnswer = function () {
            var answerCounter = 0;
            _this.shortAnswers.forEach(function (answer) {
                if (answer.userAnswer !== '' && answer.userAnswer !== undefined) {
                    answerCounter++;
                }
            });
            if (answerCounter === _this.shortAnswers.length) {
                return true;
            }
            else {
                return false;
            }
        };
        var qAnsweredChecks = {
            mc: checkMcAnswer,
            mc_multi: checkMcAnswer,
            tf: checkMcAnswer,
            short_answer: checkShortAnswer,
        };
        var validator = qAnsweredChecks[this.question.type] || checkMcAnswer;
        return validator();
    };
    PollQuestionComponent.prototype.onOnline = function () {
        window.location.reload();
    };
    return PollQuestionComponent;
}());
export { PollQuestionComponent };
